import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'
import EventTabs from '@/views/EventTabs.vue'
import EventScheduleTab from '@/views/EventScheduleTab.vue'
import EventAttendeesTab from '@/views/EventAttendeesTab.vue'
import EventInfoTab from '@/views/EventInfoTab.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/event/'
  },
  {
    path: '/event/',
    component: EventTabs,
    children: [
      {
        path: '',
        redirect: '/event/schedule'
      },
      {
        path: 'schedule',
        component: EventScheduleTab
      },
      {
        path: 'attendees',
        component: EventAttendeesTab
      },
      {
        path: 'info',
        component: EventInfoTab
      }
    ]
  },
  {
    path: '/import',
    component: () => import('@/views/AttendeesImport.vue')
  },
  {
    path: '/auth',
    component: () => import('@/views/AuthPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
